export const HOLIDAY_TYPES = {
  NATIONAL: { color: 'bg-primary/10 text-primary' },
  REGIONAL: { color: 'bg-green-950/30 text-green-400' },
  RELIGIOUS: { color: 'bg-purple-950/30 text-purple-400' },
  COMPANY: { color: 'bg-orange-950/30 text-orange-400' },
  OPTIONAL: { color: 'bg-muted text-foreground' },
};

export const COUNTRIES = ['Tunisie', 'Maroc', 'France', 'Qatar', 'Algérie'];
